module.exports = __webpack_public_path__ + "aae4b0e96b6332abdd7969dc1887ec25.pdf";